"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#000000' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size
  }, restProps, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.7608 14.1667H16.7391M10.7608 14.1667L9.16663 17.5M10.7608 14.1667L13.1485 9.17419C13.3409 8.77189 13.4371 8.57075 13.5688 8.50718C13.6832 8.4519 13.8167 8.4519 13.9311 8.50718C14.0628 8.57075 14.159 8.77189 14.3514 9.17419L16.7391 14.1667M16.7391 14.1667L18.3333 17.5M1.66663 4.16667H6.66663M6.66663 4.16667H9.58329M6.66663 4.16667V2.5M9.58329 4.16667H11.6666M9.58329 4.16667C9.16984 6.63107 8.21045 8.86349 6.80458 10.737M8.33329 11.6667C7.82285 11.4373 7.30217 11.1184 6.80458 10.737M6.80458 10.737C5.67748 9.87314 4.66893 8.68886 4.16663 7.5M6.80458 10.737C5.46734 12.5191 3.72615 13.9765 1.66663 15",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;